import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Pack Cierre Express',
    desc: '25 Respuestas Rápidas para WhatsApp e Instagram.',
    value: '$12.000'
  }, {
    num: '02',
    title: 'Operación Sin Caos',
    desc: 'Checklists de producción y entrega para el sábado perfecto.',
    value: '$9.000'
  }, {
    num: '03',
    title: 'Kit Mensajes Emocionales',
    desc: '120 frases para tarjetas (Mamá, Pareja, Amigos).',
    value: '$8.500'
  }, {
    num: '04',
    title: 'Mini-Guía Anti-Cancelaciones',
    desc: 'Políticas y mensajes para blindar tu seña.',
    value: '$7.500'
  }, {
    num: '05',
    title: 'Pack Contenido 7 Días',
    desc: 'Historias, Copys y Reeles listos para publicar hoy.',
    value: '$11.000'
  }, {
    num: '06',
    title: 'Plantillas Express de Control',
    desc: 'Registro de pedidos, caja y costos (Sheets + Cuaderno).',
    value: '$10.000'
  }];
  return <section className="py-20 px-4 bg-brand/5 border-y border-brand/20 pt-[25px] pb-[25px]" data-id="element-48">
      <div className="max-w-6xl mx-auto" data-id="element-49">
        <div className="text-center mb-16" data-id="element-50">
          <div className="inline-flex items-center space-x-2 bg-brand text-white px-6 py-2 rounded-full mb-6 font-bold shadow-[0_0_20px_rgba(249,115,22,0.4)]" data-id="element-51">
            <Gift className="w-5 h-5" data-id="element-52" />
            <span data-id="element-53">SIEMPRE INCLUIDOS</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black" data-id="element-54">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-55">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-6 relative overflow-hidden group hover:border-brand transition-colors" data-id="element-56">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand/5 transition-colors" data-id="element-57">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-58">
                <div className="text-brand font-bold mb-2" data-id="element-59">
                  Bono {bonus.num}
                </div>
                <h4 className="text-xl font-bold mb-3 text-white" data-id="element-60">
                  {bonus.title}
                </h4>
                <p className="text-gray-400 mb-6" data-id="element-61">{bonus.desc}</p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-dark-border" data-id="element-62">
                  <span className="text-gray-500 line-through text-sm" data-id="element-63">
                    Valor {bonus.value}
                  </span>
                  <span className="text-brand font-black" data-id="element-64">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-brand/20 to-brand/5 border border-brand/30 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-65">
          <div className="text-gray-300 mb-2" data-id="element-66">Valor total de los 6 bonos</div>
          <div className="flex items-center justify-center space-x-4" data-id="element-67">
            <span className="text-3xl text-gray-500 line-through font-bold" data-id="element-68">
              $58.000
            </span>
            <span className="md:text-4xl font-black text-brand text-[26px]" data-id="element-69">
              → GRATIS
            </span>
          </div>
          <div className="text-sm text-gray-400 mt-2" data-id="element-70">
            ✅ Incluidos con tu Ultrapack
          </div>
        </motion.div>
      </div>
    </section>;
}